import ReactQueryProvider from '@/API/ReactQueryProvider';
import OpenModalButton from '@/pages/views/OpenModalButton';
import React from 'react';

const OpenModalGeneral = () => {
  return (
    <ReactQueryProvider>
      <OpenModalButton />
    </ReactQueryProvider>
  );
};
export default OpenModalGeneral;
